import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PrivateRoute = ({ children, role }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  const roles = Array.isArray(role) ? role : [role];
  
  // First check role
  if (!roles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  // Then check approval for agents
  if (['agent', 'sub-agent'].includes(user.role)) {
    if (!user.isApproved) {
      console.log('Agent not approved, redirecting to pending approval');
      return <Navigate to="/pending-approval" />;
    }
  }

  return children;
};

export default PrivateRoute;
